import React, { useCallback, useEffect, useRef, useState } from "react";
import { sidechatdata } from "../../../Common/data";
import { Link } from "react-router-dom";

const SideChat = ({ toggleChat} : any) => {
  const [voiceSearch, setVoiceSearch] = useState("");

  const handleSearchChange = (event: any) => {
    setVoiceSearch(event.target.value);
  };

  const [isdropOpen, setDropOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const toggleOpen = useCallback(() => {
    setDropOpen((previousState) => !previousState);
  }, []);

  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        if (isdropOpen && toggleOpen) {
          toggleOpen();
        }
      }
    };

    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };  
  }, [isdropOpen, toggleOpen]);

  return (
    <React.Fragment>
      <div className="lg:max-w-[326px] w-full bg-white flex-1 flex flex-col gap-2 border border-black/10 dark:bg-darklight dark:border-darkborder rounded">
        <div className="flex items-center justify-between gap-2 px-4 py-2 bg-light/20 dark:bg-white/5">
          <div className="relative w-full max-w-[160px]">
            <input
              type="text"
              id="voice-search"
              className="h-10 form-input dark:text-white/80 dark:placeholder:text-white/30 dark:border-darkborder dark:bg-dark dark:focus:border-white/30"
              placeholder="Search..."
              required
              value={voiceSearch}
              onChange={handleSearchChange}
            />
          </div>
          <div className="flex items-center gap-2">
            <button
              type="button"
              className="flex items-center justify-center w-6 h-6 text-black transition-all duration-300 rounded sm:w-9 sm:h-9 dark:text-darkmuted dark:hover:text-white dark:hover:bg-white/5 hover:bg-light/50"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                className="w-5 h-5"
              >
                <path
                  fill="currentColor"
                  d="M3 2H19.0049C20.1068 2 21 2.89821 21 3.9908V20.0092C21 21.1087 20.1074 22 19.0049 22H3V2ZM7 4H5V20H7V4ZM9 20H19V4H9V20ZM11 16C11 14.3431 12.3431 13 14 13C15.6569 13 17 14.3431 17 16H11ZM14 12C12.8954 12 12 11.1046 12 10C12 8.89543 12.8954 8 14 8C15.1046 8 16 8.89543 16 10C16 11.1046 15.1046 12 14 12ZM22 6H24V10H22V6ZM22 12H24V16H22V12Z"
                ></path>
              </svg>
            </button>
            <div className="ltr:ml-auto rtl:mr-auto dropdown">
              <Link
                to="#"
                onClick={toggleOpen}
                className="flex items-center justify-center w-6 h-6 text-black transition-all duration-300 rounded sm:w-9 sm:h-9 dark:text-darkmuted dark:hover:text-white dark:hover:bg-white/5 hover:bg-light/50"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  className="w-5 h-5"
                >
                  <path
                    fill="currentColor"
                    d="M12 3C11.175 3 10.5 3.675 10.5 4.5C10.5 5.325 11.175 6 12 6C12.825 6 13.5 5.325 13.5 4.5C13.5 3.675 12.825 3 12 3ZM12 18C11.175 18 10.5 18.675 10.5 19.5C10.5 20.325 11.175 21 12 21C12.825 21 13.5 20.325 13.5 19.5C13.5 18.675 12.825 18 12 18ZM12 10.5C11.175 10.5 10.5 11.175 10.5 12C10.5 12.825 11.175 13.5 12 13.5C12.825 13.5 13.5 12.825 13.5 12C13.5 11.175 12.825 10.5 12 10.5Z"
                  ></path>
                </svg>
              </Link>
             { isdropOpen &&
              <ul className="ltr:right-0 rtl:left-0 whitespace-nowrap">
                <li>
                  <Link to="#">New Group</Link>
                </li>
                <li>
                  <Link to="#">Starred Massage</Link>
                </li>
                <li>
                  <Link to="#">Setting</Link>
                </li>
              </ul>}
            </div>
          </div>
        </div>
        <ul className="space-y-2 h-[calc(100vh-277px)] px-4 overflow-y-auto">
          {sidechatdata.map((item: any, idx: number) => (
            <li key={idx}>
              <Link
                to="#"
                onClick={() => toggleChat(true)}
                className={item.selectedchat === true ? `flex items-start gap-2 p-2 transition-all duration-300 rounded bg-light/50 dark:bg-white/10 dark:hover:bg-white/10 hover:border-transparent hover:bg-light/50` : `flex items-start gap-2 p-2 transition-all duration-300 rounded bg-light/20 dark:bg-white/5 dark:hover:bg-white/10 hover:border-transparent hover:bg-light/50`}
              >
                <div className="flex items-center flex-1 gap-2 p-1">
                  {item.multipleavatar === false ? (
                    <div className="w-9 h-9">
                      <img
                        className="flex-none object-cover overflow-hidden rounded-full"
                        src={item.avatar}
                        alt=""
                      />
                    </div>
                  ) : (
                    <div className="relative flex items-center justify-start text-black w-9 h-9">
                      <img
                        className="absolute top-0 left-0 object-cover w-5 h-5 overflow-hidden rounded-full ring-2 ring-white"
                        src={item.avatar1}
                        alt=""
                      />
                      <img
                        className="absolute top-0 right-0 object-cover w-5 h-5 overflow-hidden rounded-full ring-2 ring-white"
                        src={item.avatar2}
                        alt=""
                      />
                      {item.avatar3 ? (
                        <img
                          className="absolute bottom-0 object-cover w-5 h-5 overflow-hidden rounded-full left-1/4 ring-2 ring-white"
                          src={item.avatar3}
                          alt=""
                        />
                      ) : (
                        <img
                          className="absolute bottom-0 left-0 object-cover w-5 h-5 overflow-hidden rounded-full ring-2 ring-white"
                          src={item.avatar4}
                          alt=""
                        />
                      )}
                      {item.numavatar ? (
                        <span className="flex justify-center items-center w-5 h-5 absolute bottom-0 right-0 text-center rounded-full object-cover bg-light text-[8px] ring-2 ring-white">
                          {item.numavatar}
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                  )}
                  <div className="flex-1 ltr:text-left rtl:text-right">
                    <p className="line-clamp-1 dark:text-white">{item.name}</p>
                    <p className="text-xs text-muted line-clamp-1">
                      {item.message}
                    </p>
                  </div>
                </div>
                <div className="ltr:text-right rtl:text-left">
                  <p className="flex-none text-xs text-muted mb-1.5">
                    {item.timestamp}
                  </p>
                  {item.unreadCount ? (
                    <span className="inline-block items-center rounded text-xs justify-center px-1.5 py-0.5 bg-purple text-white">
                      {item.unreadCount}
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </React.Fragment>
  );
};

export default SideChat;
